<template>
  <v-list-item @click.stop="dialog = true">
    <v-list-item-icon>
      <v-icon>mdi-help-circle</v-icon>
    </v-list-item-icon>
    <v-list-item-content>Guide</v-list-item-content>
    <v-dialog 
      v-model     = "dialog"
      width       = "80%"
      max-height  = "80%"
    >
      <v-card>
        <iframe name="docIframe"
                src="./docs/user-guide/index.html"
                style="width: 100%; height: 80vh"
        ></iframe>
      </v-card>
    </v-dialog>
  </v-list-item>
</template>

<script>
export default {
  name:  'UserGuide',
  props: ['on'],
  data:  function () {
    return {
      dialog: false,
      guide:  null,
    };
  },
};
</script>

<style scoped>
.close-button {
    position: absolute;
    right: 3px;
    top: 3px;
}
</style>
